/**
 * A full page load at the path: the Redux stores of the previous context are dropped, so nothing of
 * one context is shown in the other.
 */
export const reloadAt = (path: string): void => {
  window.location.assign(path);
};
